import {FullPageSpinner} from "../loading/Spinner";
import {FC, useEffect, useState} from "react";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {useAuth} from "../auth/AuthContext";
import {requiresVerification} from "../auth/types";

export type VerifyEmailProps = {
  oobCode: string;
};

export const VerifyEmail: FC<VerifyEmailProps> = ({oobCode}) => {
  const [submitting, setSubmitting] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  useEffect(() => {
    if (!oobCode) { setError(true); setSubmitting(false); return; }

    AccountsAPI.verifyEmail(oobCode)
      .then(() => {setSubmitting(false); setSuccess(true);})
      .catch(() => {setSubmitting(false); setError(true);});
  }, [oobCode]);

  if (submitting) {
    return (
      <div data-testid="verify-email-submitting">
        <FullPageSpinner />
      </div>
    );
  }

  // submission finished successfully: show lightweight UI and prompt user to return to app
  if (success) {
    return (
      <div data-testid="verify-email-success">
        <h2 className="text-center mb-4">Email verified!</h2>
        <p className="text-center">Please close this tab and return to the app.</p>
      </div>
    );
  }

  // submission finished with error: show a lightweight UI and prompt user to try again from elsewhere
  if (error) {
      return (
          <div data-testid="verify-email-error">
              <h2 className="text-center mb-4">We couldn&apos;t verify your email.</h2>
              <p className="text-center">Please try again or request a new link.</p>
          </div>
      );
  }

  return <></>;
};
